import React, { useState, useEffect } from "react";
import UserHeader from "../Header/UserHeader/UserHeader";
import { authData } from "../../redux/auth/authSlice";
import { FaBars } from "react-icons/fa";
import { useSelector } from "react-redux";
import {
  Select,
  FormControl,
  MenuItem,
  Typography,
  Paper,
} from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { API } from "aws-amplify";
import config from "../../config/aws-exports";
import Skeleton from "@material-ui/lab/Skeleton";
import swal from "sweetalert";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { ReactComponent as Close } from "../../assets/svg/close_black_24dp.svg";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .slick-arrow": { color: "black" },
    "& .slick-prev:before": { color: "black", fontSize: 27 },
    "& .slick-next:before": { color: "black", fontSize: 27 },
  },
  paperAnnounce: {
    textAlign: "start",
    color: theme.palette.text.secondary,
    width: "100%",
  },
  paperEvents: {
    textAlign: "start",
    color: theme.palette.text.secondary,
    width: "100%",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "none",
    transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)",
  },
  paper: {
    "& .MuiDialog-paperWidthSm": {
      height: "80%",
      width: "90%",
      padding: "50px 0px 0px",
      "@media (min-height: 800px)": { height: "72rem" },
    },
  },
  content: {
    ".MuiDialogContent-root": { overflowY: "hidden" },
  },
  mainGrid: {
    width: "100%",
    margin: 0,
    "& > div": { padding: "15px!important" },
  },
  listContents: {
    marginLeft: "1rem",
    justifyContent: "left",
    "& > p": { overflow: "auto" },
  },
  modalHeading: {
    position: "absolute",
    top: "0",
    left: "30px",
    maxWidth: "800px",
    "@media (max-width: 520px)": { padding: "16px 0px" },
  },
  paperSectionMainStyle: {
    width: "40rem",
    backgroundColor: "#d5e3ef",
    padding: "1rem",
    boxShadow: "0 0 1px #0000002e",
    "@media (max-width: 520px)": { width: "100%" },
  },
  paperSectionStyle: {
    boxShadow: "0 0 8px #0000002e",
    marginTop: "2rem",
  },
  buttonSectionStyle: {
    boxShadow: "0 0 8px #0000002e",
    padding: "1rem",
    fontSize: "1.5rem",
  },
}));

const Iamarks = ({ handleToggleSidebar }) => {
  const classes = useStyles();
  const [selectedSemester, setSelectedSemester] = useState("");
  const [selectedPgm, setSelectedPgm] = useState(null);
  const [iaMarksData, setIaMarksData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedTopic, setSelectedTopic] = useState([]);
  const [currentTopic, setCurrentTopic] = useState([]);
  const [reason, setReason] = useState("");
  const [reasonerr, setReasonErr] = useState("");

  const [open, setOpen] = useState(false);
  const userDetails = useSelector(authData);

  const programlist = userDetails.data?.bpdata || [];

  const tableStyle = {
    borderCollapse: "collapse",
    width: "100%",
  };

  const tdStyle1 = {
    padding: "8px",
    textAlign: "center",
    border: "1px solid #ddd",
    fontSize: "14px",
  };

  const thStyle = {
    backgroundColor: "var(--sub-heading-color)",
    padding: "8px",
    textAlign: "center",
    border: "1px solid #ddd",
    fontSize: "16px",
    color: "#ddd",
  };

  const thStyle1 = {
    backgroundColor: "var(--sub-heading-color)",
    padding: "8px",
    textAlign: "center",
    border: "1px solid #ddd",
    fontSize: "16px",
    color: "#ddd",
  };

  const tdStyle = {
    padding: "8px",
    textAlign: "center",
    border: "1px solid #ddd",
    fontSize: "1.4rem",
    cursor: "pointer",
    fontWeight: "500",
    color: "var(--sub-heading-color)",
    // or "500", "normal", etc.
  };

  useEffect(() => {
    if (programlist.length > 0 && !selectedPgm) {
      setSelectedPgm(programlist[0]);
    }
  }, [programlist, selectedPgm]);

  useEffect(() => {
    console.log("useEffect triggered: ", { selectedPgm, selectedSemester });
    if (selectedPgm && selectedSemester !== "") {
      const filteredCourses =
        selectedPgm.tcourses?.filter(
          (course) => String(course.sem) === String(selectedSemester)
        ) || [];
      const topicIds = filteredCourses.map((course) => course.bcid);
      console.log("Filtered courses: ", filteredCourses);
      console.log("Topic IDs: ", topicIds);
      setSelectedTopic(topicIds);
      if (topicIds.length > 0) {
        getIaMarks(topicIds);
      } else {
        console.warn("No topic IDs found for selected semester");
        setIaMarksData([]);
      }
    } else {
      setIaMarksData([]);
      setSelectedTopic([]);
    }
  }, [selectedPgm, selectedSemester]);

  const handleProgramChange = (event) => {
    const selectedProgram = event.target.value;
    console.log("Program changed: ", selectedProgram);
    setSelectedPgm(selectedProgram);
    setSelectedSemester(""); // Reset semester when program changes
    setIaMarksData([]); // Clear IA marks data
    setSelectedTopic([]); // Clear topic IDs
  };

  const handleSemesterChange = (event) => {
    const newSemester = event.target.value;
    console.log("Semester changed: ", newSemester);
    setSelectedSemester(newSemester);
  };

  async function getIaMarks(topicIds) {
    console.log("Calling getIaMarks with topic IDs: ", topicIds);
    if (!topicIds || topicIds.length === 0) {
      console.warn("No topic IDs provided, skipping API call");
      setIaMarksData([]);
      return;
    }

    const bodyParam = {
      body: {
        oid: config.aws_org_id,
        bpid: selectedPgm.bpid,
        topicids: topicIds,
        eid: userDetails.eid,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    setLoading(true);
    try {
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        "/getIaMarks",
        bodyParam
      );
      console.log("getIaMarks response: ", response);
      setIaMarksData(response);
    } catch (error) {
      console.error("Error fetching IA marks:", error);
      setIaMarksData([]);
      swal({
        title: "Error",
        text: "Failed to fetch IA marks. Please try again.",
        icon: "error",
        dangerMode: true,
      });
    } finally {
      setLoading(false);
    }
  }

  const handleRaiseConcern = async (item, concernRaised, topicName) => {
    if (concernRaised == "true" && reason == "") {
      setReasonErr("Please enter the reason for concern");
      return;
    }

    const bodyParam = {
      body: {
        oid: config.aws_org_id,
        bpid: selectedPgm.bpid,
        topicids: item,
        eid: userDetails.eid,
        concernRaised: concernRaised,
        topicName: topicName,
        email: userDetails?.email,
        name: userDetails?.name,
        reason: reason,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    handleClose();
    setLoading(true);
    try {
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        "/UpdateIaConcern",
        bodyParam
      );
      console.log("UpdateIaConcern response: ", response);
      if (response.statusCode === 200) {
        swal({
          title: "Success",
          text: "Concern updated successfully",
          icon: "success",
          dangerMode: false,
        });
      } else {
        throw new Error("Failed to update concern");
      }
    } catch (error) {
      console.error("Error updating concern:", error);
      swal({
        title: "Error",
        text: "Failed to update concern. Please try again.",
        icon: "error",
        dangerMode: true,
      });
    } finally {
      if (selectedTopic.length > 0) {
        await getIaMarks(selectedTopic);
      }
      setLoading(false);
      
    }
  };

  const handleConcern = (topicKey, concernRaised, topicName) => {
    swal({
      title: "Are you sure?",
      text: `You want to ${concernRaised === "true" ? "raise" : "No"} concern!`,
      icon: "warning",
      buttons: { confirm: "Yes", cancel: "No" },
      dangerMode: true,
    }).then((willSave) => {
      if (willSave) {
        handleRaiseConcern(topicKey, concernRaised, topicName);
      }
    });
  };

  const handleReasonChange = (event, newValue, oid) => {
    setReason(event.target.value);
  };

  const handleClose = () => {
    setOpen(false);
    setCurrentTopic([]);
    setReason("");
    setReasonErr("");
  };

  return (
    <main>
      <div className="btn-toggle" onClick={() => handleToggleSidebar(true)}>
        <FaBars />
      </div>
      <UserHeader />

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div
            style={{
              width: "50%",
              height: "fit-content",
              background: "transparent",
              alignitems: "center",
              justifycontent: "center",
              backgroundColor: "white",
              display: "grid",
              borderRadius: "0.5rem",
              padding: "2rem",
            }}
          >
            <div>
              <div
                onClick={handleClose}
                style={{ textAlign: "right", cursor: "pointer" }}
              >
                <Close />
              </div>
              <div
                style={{
                  display: "grid",
                  gap: "2rem",
                  background: "white",
                  gridTemplateColumns: "20rem 50rem",
                }}
              >
                <div
                  style={{
                    textAlign: "left",
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                >
                  Course Name
                </div>

                <div style={{ fontWeight: "bold", fontSize: "14px" }}>
                  {currentTopic.topicName}
                </div>

                <div
                  style={{
                    textAlign: "left",
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                >
                  Reason for concern <span style={{ color: "red" }}>*</span>
                </div>
                <textarea
                  type="text"
                  style={{
                    flexGrow: "1",
                    height: "100px",
                    outline: "none",
                    fontSize: "1.5rem",
                    padding: "1rem",
                    border: "1px solid #01498e",
                    boxShadow: "0px 0px 5px 0px lightgrey",
                    width: "45rem",
                  }}
                  value={reason}
                  onChange={(e) => {
                    handleReasonChange(e);
                  }}
                />
              </div>

              <div>
                <div
                  style={{
                    display: "flex",
                    gap: "50px",
                    justifyContent: "center",
                    paddingTop: "2rem",
                  }}
                >
                  <button
                    onClick={() => {
                      handleRaiseConcern(
                        currentTopic.topicKey,
                        "true",
                        currentTopic.topicName
                      );

                      console.log("Current Topic", currentTopic);
                    }}
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold",
                      backgroundColor: "var(--sub-heading-color)",
                      color: "white",
                      border: "none",
                      borderRadius: "4px",
                    }}
                  >
                    Yes
                  </button>
                  <button
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold",
                      backgroundColor: "white",
                      color: "var(--sub-heading-color)",
                      border: "0.5px solid var(--sub-heading-color)",
                      borderRadius: "4px",
                    }}
                    onClick={() => {
                      handleClose();
                    }}
                  >
                    No
                  </button>
                </div>

                <p
                  style={{
                    color: "red",
                    textAlign: "center",
                    marginTop: "2rem",
                    fontSize: "12px",
                  }}
                >
                  {reasonerr}
                </p>
              </div>
            </div>
          </div>
        </Fade>
      </Modal>
      <h2
        style={{ fontSize: "1.5rem", fontWeight: "700", marginBottom: "2rem" }}
      >
        IA Marks
      </h2>

      <Paper className={classes.paperSectionMainStyle}>
        <h4>Program</h4>
        {programlist.length > 0 ? (
          <FormControl
            sx={{ bgcolor: "white", minWidth: "100%", m: "1rem 0" }}
            size="small"
          >
            <Select
              labelId="demo-select-small-label"
              id="demo-select-small"
              value={selectedPgm || ""}
              onChange={handleProgramChange}
              style={{ fontSize: "1.5rem" }}
            >
              {programlist.map((prog, idx) => (
                <MenuItem key={idx} value={prog}>
                  {prog.ptitle}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        ) : (
          <Typography>No programs available</Typography>
        )}
      </Paper>

      {selectedPgm && (
        <Paper
          className={classes.paperSectionMainStyle}
          style={{ marginTop: "1rem" }}
        >
          <h4>Semester</h4>
          <FormControl
            sx={{ bgcolor: "white", minWidth: "100%", m: "1rem 0" }}
            size="small"
          >
            <Select
              labelId="demo-select-small-label"
              id="demo-select-small"
              value={selectedSemester}
              onChange={handleSemesterChange}
              style={{ fontSize: "1.5rem" }}
            >
              <MenuItem value={""} disabled>
                Select Semester
              </MenuItem>
              <MenuItem value={1}>Semester 1</MenuItem>
              <MenuItem value={2}>Semester 2</MenuItem>
              <MenuItem value={3}>Semester 3</MenuItem>
              <MenuItem value={4}>Semester 4</MenuItem>
              <MenuItem value={5}>Semester 5</MenuItem>
              <MenuItem value={6}>Semester 6</MenuItem>
            </Select>
          </FormControl>
        </Paper>
      )}

      {loading ? (
        <div>
          {[...Array(4)].map((_, idx) => (
            <Typography key={idx} component="list" variant="h1">
              <Skeleton />
            </Typography>
          ))}
        </div>
      ) : selectedPgm && selectedSemester && iaMarksData.length > 0 ? (
        <Paper className={classes.paperSectionStyle}>
          <div
            style={{
              // padding: "1rem",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          ></div>
          <table style={tableStyle}>
            <thead>
              <tr>
                <th style={thStyle1}>Course</th>
                <th style={thStyle1}>Marks Scored</th>
                <th style={thStyle}>Concern Status</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(iaMarksData[0]?.topics || {}).map((topicKey) => {
                const topic = iaMarksData[0]?.topics[topicKey];
                topic.topicKey = topicKey;

                console.log("topic",topic)
                return (
                  topic?.showIaMarks && (
                    <tr key={topicKey}>
                      <td style={tdStyle}>{topic.topicName}</td>
                      <td style={tdStyle}>{topic.Iamarks} / 25</td>
                      <td style={tdStyle1}>
                        {topic?.concernRaised ? (
                          <button
                            style={{
                              backgroundColor: "var(--sub-heading-color)",
                              width: "13rem",
                              height: "30px",
                              fontSize: "1.4rem",
                              border: "none",
                              color: "white",
                              borderRadius: "4px",
                              fontWeight: "500",
                            }}
                          >
                            {topic.concernRaised === "true"
                              ? "Concern Raised"
                              : topic.concernRaised === "Updated"
                              ? "Updated"
                              : "No Concern"}
                          </button>
                        ) : (
                          <div>
                            {topic.showConcernButton && (
                              <>
                               
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "1rem",
                                    justifyContent: "center",
                                  }}
                                >
                                  <button
                                    
                                    style={{
                                      backgroundColor:
                                        "var(--sub-heading-color)",
                                      width: "13rem",
                                      height: "30px",
                                      fontSize: "1.4rem",
                                      border: "none",
                                      color: "white",
                                      borderRadius: "4px",
                                      fontWeight: "500",
                                    }}
                                    onClick={() => {
                                      setCurrentTopic(topic);
                                      setOpen(true);
                                    }}
                                  >
                                    Raise Concern
                                  </button>
                                  <button
                                    onClick={() =>
                                      handleConcern(topicKey, "false")
                                    }
                                    style={{
                                      backgroundColor:
                                        "var(--sub-heading-color)",
                                      width: "13rem",
                                      height: "30px",
                                      fontSize: "1.4rem",
                                      border: "none",
                                      color: "white",
                                      borderRadius: "4px",
                                      fontWeight: "500",
                                    }}
                                  >
                                    No Concern
                                  </button>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "0.5rem",
                                    alignItems: "center",
                                    fontSize: "1.2rem",
                                    justifyContent: "center",
                                  }}
                                >
                                  <InfoOutlinedIcon
                                    style={{ width: "1.2rem" }}
                                  />
                                  <p>
                                    These options will be available only for 72
                                    hours from time of visibility
                                  </p>
                                </div>
                              </>
                            )}
                          </div>
                        )}
                      </td>
                    </tr>
                  )
                );
              })}
            </tbody>
          </table>
        </Paper>
      ) : (
        selectedPgm &&
        selectedSemester && (
          <Typography>
            No IA marks available for the selected program and semester.
          </Typography>
        )
      )}
    </main>
  );
};

export default Iamarks;
